var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "mb-4 px-5", attrs: { id: _vm.action.loader_id } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", transition: "scale-transition" } },
        [
          _vm.isOwner ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "message__container",
              attrs: { color: _vm.coContainerColor }
            },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "message__container--owner",
                      attrs: { column: "" }
                    },
                    [
                      _c("span", {
                        class: _vm.coTextColor,
                        domProps: {
                          textContent: _vm._s(
                            _vm.getFullName(_vm.action.actor.entity)
                          )
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isUploading
                    ? [
                        _vm.action.error
                          ? _c(
                              "v-layout",
                              {
                                attrs: {
                                  column: "",
                                  "justify-center": "",
                                  "align-center": "",
                                  "fill-height": ""
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.coTextColor,
                                    staticStyle: {
                                      "font-size": "80px",
                                      "margin-left": "auto",
                                      "margin-right": "auto",
                                      padding: "10px 0"
                                    }
                                  },
                                  [_vm._v("warning")]
                                )
                              ],
                              1
                            )
                          : [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "mt-2 mb-2",
                                  attrs: { "justify-center": "" }
                                },
                                [
                                  _c(
                                    "v-progress-circular",
                                    {
                                      key: _vm.action.fakeId,
                                      attrs: {
                                        rotate: 90,
                                        size: 100,
                                        width: 15,
                                        color: "secondary",
                                        value: _vm.action.percentage
                                      }
                                    },
                                    [
                                      _c("span", { class: _vm.coTextColor }, [
                                        _vm._v(
                                          _vm._s(_vm.action.percentage) + "%"
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "message__container--owner",
                                  class: _vm.coTextColor,
                                  staticStyle: { "text-align": "center" },
                                  attrs: { column: "" }
                                },
                                [
                                  _c("div", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("LBL_UPLOADING")
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                      ]
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            "min-width": "100px",
                            "min-height": "100px"
                          }
                        },
                        [
                          _vm.source.attachment.media.ownType === "image" ||
                          _vm.source.attachment.media.type === "image"
                            ? _c("div", [
                                _c("img", {
                                  directives: [
                                    { name: "img", rawName: "v-img" }
                                  ],
                                  staticClass: "message__image",
                                  attrs: {
                                    src: _vm.source.attachment.media.link
                                  }
                                })
                              ])
                            : _vm.source.attachment.media.ownType === "video" ||
                              _vm.source.attachment.media.type === "video"
                            ? _c("div", [
                                _c(
                                  "video",
                                  {
                                    staticClass: "message__video",
                                    attrs: { controls: "" }
                                  },
                                  [
                                    _c("source", {
                                      attrs: {
                                        src: _vm.source.attachment.media.link
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("LBL_HTML5_REQUIRED")) +
                                        "\n              "
                                    ),
                                    _c("v-icon", [_vm._v("movie")])
                                  ],
                                  1
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "mt-1": "",
                                        "mb-1": "",
                                        "text-xs-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "text-decoration": "none"
                                          },
                                          attrs: {
                                            href:
                                              _vm.source.attachment.media
                                                .downloadLink,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              class: _vm.coTextColor,
                                              attrs: { size: "5vh" }
                                            },
                                            [_vm._v("description")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h3",
                                            { staticClass: "secondary--text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.documentType(
                                                    _vm.source.attachment.media
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            class: _vm.coTextColor,
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.source.attachment.media.name
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                        ]
                      )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _vm.isOwner ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c("message-time-notif-status", { attrs: { source: _vm.source } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.action.error
        ? _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "10px 5px" } },
            [
              _c(
                "v-icon",
                { staticStyle: { "font-size": "18px", color: "red" } },
                [_vm._v("error_outline")]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-style": "italic", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.action.error))]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-279ecb4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279ecb4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message-uploading/template.html
// module id = null
// module chunks = 